/**
 * Tracks whether we have already reconciled the browser session with the server
 * via `restoreSession()` so we do not repeat GET /users/me on every protected-route remount.
 * Reset on logout and when a new OAuth access token is bootstrapped from the URL.
 */
let serverSessionValidated = false;

export function resetServerSessionValidation(): void {
  serverSessionValidated = false;
}

export function markServerSessionValidated(): void {
  serverSessionValidated = true;
}

export function isServerSessionValidated(): boolean {
  return serverSessionValidated;
}
